export const BASE_URL = 'https://api-loyalty.shirecake.com/api/v1';

export enum CustomerRank {
    BRONZE = 'BRONZE',
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    DIAMOND = 'DIAMOND',
}

export const VOUCHER_EVENT_TYPE = {
    UP_SILVER: "UP_SILVER",
    UP_GOLD: "UP_GOLD",
    UP_DIAMOND: "UP_DIAMOND",
    ZALO_OA_SUBSCRIBE: "ZALO_OA_SUBSCRIBE",
};